import React from "react";
import { useHistory } from "react-router-dom";
import {
  HistoryOutlined,
  HomeOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  AppstoreOutlined,
  TeamOutlined,
  RobotOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Card, Row, Col, Space } from "antd";

const StasticsView = () => {
  const history = useHistory();

  const cardStyle = {
    padding: 16,
    fontFamily: "Roboto,sans-serif",
    borderRadius: "12px",
    border: "1px solid #EAEEF0",
    boxShadow: "none",
    transition: "transform 0.2s, box-shadow 0.2s",
    cursor: "pointer",
  };

  const cardHoverStyle = {
    transform: "scale(1.05)",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
  };

  return (
    <div
      style={{
        height: "auto",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: "0",
      }}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Card
            style={cardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, cardHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "";
            }}
            onClick={() => {
              history.push("/statistics/execution");
            }}
          >
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Space>
                <HistoryOutlined style={{ marginRight: 8 }} />
                <span>Execution Statistics</span>
              </Space>
              <RightOutlined style={{ fontWeight: "bold" }} />
            </Space>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            style={cardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, cardHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "";
            }}
            onClick={() => {
              history.push("/statistics/automation");
            }}
          >
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Space>
                <BarChartOutlined style={{ marginRight: 8 }} />
                <span>Automation Statistics</span>
              </Space>
              <RightOutlined style={{ fontWeight: "bold" }} />
            </Space>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            style={cardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, cardHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "";
            }}
            onClick={() => {
              history.push("/statistics/user");
            }}
          >
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Space>
                <TeamOutlined style={{ marginRight: 8 }} />
                <span>User Statistics</span>
              </Space>
              <RightOutlined style={{ fontWeight: "bold" }} />
            </Space>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            style={cardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, cardHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "";
            }}
            onClick={() => {
              history.push("/statistics/assistant");
            }}
          >
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Space>
                <RobotOutlined style={{ marginRight: 8 }} />
                <span>Assistant Statistics</span>
              </Space>
              <RightOutlined style={{ fontWeight: "bold" }} />
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default StasticsView;
